import { useEffect, useRef } from 'react'

/**
 * Runs the callback only when component unmounts
 */
export function useUnmount(callback: () => any) {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    return () => {
      callbackRef.current()
    }
  }, [])
}
